import { Header, Avatar } from '@primer/react'
import { MarkGithubIcon } from '@primer/octicons-react'
import tysmIcon from './images/tysm_logo.png'

function TysmHeader() {
    return (
        <Header>
  <Header.Item sx={{mr: 2}}>
    <Header.Link href="#">
      <img src={tysmIcon} alt="tysm logo" width={30} height={30} style={{marginRight: 3}}/>
      <span>Legal</span>
    </Header.Link>
  </Header.Item>
</Header>
    )
}

export default TysmHeader